import React, {PureComponent} from 'react';

export default class Video extends PureComponent {
    state = {
        propsSrc: this.props.src,
        src: this.props.src,
    };

    static getDerivedStateFromProps(newProps, oldState) {
        if (oldState.propsSrc !== newProps.src) {
            return {
                propsSrc: newProps.src,
                src: newProps.src,
            };
        }

        return null;
    }

    componentDidMount() {
        if (window.cordova && window.cordova.platformId === 'android') {
            if (!this.state.src) {
                return;
            }

            let src = this.state.src
                .split('/')
                .pop()
                .replace(/-/g, '')
                .toLowerCase();

            try {
                window.cordova.exec(
                    video => this.setState({src: video}),
                    () => console.error('Alert della error callback'),
                    'VideoLocalPlugin',
                    'initialize',
                    [src]
                );
            } catch (e) {
                console.error(e);
            }
        }
    }

    componentDidUpdate(oldProps) {
        if (oldProps.src !== this.props.src) {
            if (window.cordova && window.cordova.platformId === 'android') {
                if (!this.state.src) {
                    return;
                }
                let src = this.state.src
                    .split('/')
                    .pop()
                    .replace(/-/g, '')
                    .toLowerCase();

                try {
                    window.cordova.exec(
                        video => this.setState({src: video}),
                        () => console.error('Alert della error callback'),
                        'VideoLocalPlugin',
                        'initialize',
                        [src]
                    );
                } catch (e) {
                    console.error(e);
                }
            }
        }
    }

    render() {
        return <video {...this.props} src={this.state.src} />;
    }
}



// WEBPACK FOOTER //
// ./src/atoms/Video.js